import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as type from "../../types";
import { forgetPasswordApi } from "../../api/common/forgotPasswordApi";
import { notification } from "antd";

function* fetchForgotPasswordSaga(action) {
  try {
    const response = yield call(forgetPasswordApi, action.payload);
    
    yield put({ type: type.FORGOT_PASSWORD_SUCCESS, data: response });

    if (response?.data?.success) {
      // Call success callback if provided
      if (action.payload.onSuccess) {
        action.payload.onSuccess(response);
      }
      yield call(notification.success, {
        message: "Success",
        description: "Password sent successfully!",
      });
    } else {
      // Call failure callback if provided
      if (action.payload.onFailure) {
        action.payload.onFailure(response?.data?.message || "User not found");
      }
      yield call(notification.error, {
        message: "Error",
        description: response?.data?.message || "Failed to send password.",
      });
    }
  } catch (error) {
    yield put({ type: type.FORGOT_PASSWORD_FAILURE, message: error.message });

    // Call failure callback if provided
    if (action.payload.onFailure) {
      action.payload.onFailure(error.message);
    }

    yield call(notification.error, {
      message: "Error",
      description: "Something went wrong. Please try again.",
    });
  }
}

export function* watchForgotPasswordSaga() {
  yield takeLatest(type.FORGOT_PASSWORD_REQUEST, fetchForgotPasswordSaga);
}
